<template>
  <div class="sidebar-meta">
    <slot name="secondary">
      <Button
        class="link help-link"
        href="http://help.promo.ai/category/newsletters-by-promo-ai/"
        target="_blank"
      >
        Need Help?
      </Button>
    </slot>

    <slot name="primary" />
  </div>
</template>

<script>
export default {
  name: "SidebarMeta",
};
</script>

<style scoped>
.sidebar-meta {
  @apply flex items-center w-full border bg-grey-lightest py-2 px-4 shadow rounded-lg mb-6;
  bottom: 0;
  z-index: 10;

  @screen md {
    @apply p-4 mb-4;
  }
}

.help-link {
  @apply text-grey-dark px-0;
  font-size: 14px;

  &:hover {
    @apply underline text-brand;
  }
}
</style>
